module.exports = __webpack_public_path__ + "static/media/pra-news.e1d38747.png";